import React, { FC } from 'react';
import '../../App.scss';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
interface IButtonProps {
  text: string;
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void | Promise<void> | object;
}

const Button: FC<IButtonProps> = ({ text, onClick }) => {
  const { t } = useTranslation();

  return (
    <button className={styles.button} onClick={onClick}>
      {t(text)}
    </button>
  );
};

export default Button;
